import { CSSProperties, FC, PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const LinkOrAWrapper = styled.div`
  text-decoration: none !important;

  a {
    text-decoration: none !important;
  }
`

type LinkOrAProps = {
  asLink: boolean
  to: string
  sameTab?: boolean
  style?: CSSProperties
  ariaLabel?: string
}

const LinkOrA: FC<PropsWithChildren<LinkOrAProps>> = ({
  asLink,
  to,
  children,
  sameTab = false,
  style,
  ariaLabel,
}) => (
  <LinkOrAWrapper style={style}>
    {asLink ? (
      <Link to={to} aria-label={ariaLabel}>
        {children}
      </Link>
    ) : (
      <a
        href={to}
        target={!sameTab ? `_blank` : `_self`}
        rel={!sameTab ? `noopener noreferrer` : ``}
        aria-label={ariaLabel}
      >
        {children}
      </a>
    )}
  </LinkOrAWrapper>
)

export default LinkOrA
